/**
 * Ödül öneri serbest metinleri — UTF-8 bozulmalarını (mojibake) düzeltir.
 * Örn. "daÄŸÄ±nÄ±k" → "dağınık" (UTF-8 baytları Latin-1 gibi okunmuşsa).
 */
export const repairOdulOneriText = (value) => {
  if (value == null) return ''
  const text = String(value)
  if (!text) return text

  const looksMojibake =
    /Ã.|Â.|Ä.|Å.|Æ.|Ø.|Þ.|ð.|ñ.|þ.|�/.test(text) ||
    /[\u00C0-\u00FF]{2,}/.test(text)

  if (!looksMojibake) return text

  try {
    const bytes = Uint8Array.from(text, (ch) => ch.charCodeAt(0) & 0xff)
    const decoded = new TextDecoder('utf-8', { fatal: true }).decode(bytes)
    if (decoded && decoded !== text) return decoded
  } catch (_) {
    /* orijinal metni koru */
  }
  return text
}

/** CSS text-transform:uppercase Türkçe İ/I bozar; gerekirse bu kullanılsın. */
export const toTurkishUpperCase = (value) =>
  String(value ?? '').toLocaleUpperCase('tr-TR')

export const toTurkishLowerCase = (value) =>
  String(value ?? '').toLocaleLowerCase('tr-TR')
